import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import classnames from "classnames";
import withReduxProvider from "web/react/redux-provider";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { hideMainNavigation } from "web/redux/ducks/main-navigation";
import environment from "web/script/modules/environment";
import styles from "./main-navigation-desktop.css";
var CATEGORY_LIMIT = 12;
var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
letters.push("0-9");

function extractVisibility(state) {
  return state.mainNavigationReducer.visible;
}

export function MainNavigationDesktop(_ref) {
  var menuData = _ref.menuData,
      featuredDesignersUrl = _ref.featuredDesignersUrl;
  var dispatch = useDispatch();
  var showContent = useReduxSelector(extractVisibility);
  var categories = menuData.menus;
  var links = menuData.links;
  var isRebrand = environment.getFeature("seo_global_rebrand_2020");
  var iconName = isRebrand ? "arrow-icon" : "chevron";

  var _useState = useState(menuData.menus[0]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  var _useState3 = useState(menuData.menus[0].menus[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedSubMenu = _useState4[0],
      setSelectedSubMenu = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedTrendMenu = _useState6[0],
      setSelectedTrendMenu = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      popularBrands = _useState8[0],
      setPopularBrands = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      expandedCategories = _useState10[0],
      setExpandedCategories = _useState10[1];

  function selectCategory(category) {
    setSelectedCategory(category);
    setSelectedSubMenu(category.menus[0]);
    setSelectedTrendMenu(null);
    setPopularBrands(null);
  }

  function selectPopularBrands(category) {
    setSelectedCategory(category);
    setSelectedSubMenu(menuData.menus[0].menus[0]);
    setSelectedTrendMenu(null);
    setPopularBrands(category.links);
  }

  useEffect(function () {
    setSelectedCategory(menuData.menus[0]);
    setSelectedSubMenu(menuData.menus[0].menus[0]);
    setSelectedTrendMenu(null);
    setPopularBrands(null);
  }, [menuData]);

  function getInteraction(callback, label) {
    return _objectSpread({}, {
      onClick: function onClick() {
        analytics.event("Menu click", "Clicked", label);
        callback();
      }
    });
  }

  function renderCategories() {
    return React.createElement("ul", {
      className: styles.menu
    }, categories.map(function (category) {
      var _classnames;

      var isPopularBrands = category.name === "popular_brands";

      function interact() {
        if (isPopularBrands) {
          selectPopularBrands(category);
        } else {
          selectCategory(category);
        }
      }

      var interaction = getInteraction(interact, "Category");
      var displayText;

      if (isPopularBrands) {
        displayText = gettext("app_header_menu.brands_title");
      }

      if (!displayText) {
        displayText = category.display_name;
      }

      return React.createElement("li", _extends({
        key: category.display_name,
        className: classnames(styles.menuItem, (_classnames = {}, _defineProperty(_classnames, styles.activeMenuItem, selectedCategory.name === category.name), _defineProperty(_classnames, styles.clickable, true), _classnames))
      }, interaction), displayText);
    }), links && links.map(function (link) {
      var isSaleLink = link.is_sale;
      return React.createElement("li", {
        key: link.text,
        className: classnames(styles.menuItem)
      }, isSaleLink && React.createElement(SVGIcon, {
        className: classnames(styles.saleTag),
        name: "tag"
      }), React.createElement("a", {
        href: link.url,
        className: styles.saleLink
      }, link.text));
    }));
  }

  function renderSubCategories() {
    var totalItems = selectedCategory.menus.length + selectedCategory.links.length;
    var hasHiddenItems = totalItems >= CATEGORY_LIMIT;
    var hideItems = hasHiddenItems && !expandedCategories[selectedCategory.name];
    return React.createElement("div", {
      className: classnames(styles.subMenu, _defineProperty({}, styles.hideExtraLinks, hideItems))
    }, React.createElement("ul", {
      className: styles.subMenu
    }, selectedCategory.menus.map(function (menu) {
      var _classnames3;

      function interact() {
        setSelectedSubMenu(menu);
        setSelectedTrendMenu(null);
      }

      var interaction = getInteraction(interact, "Subcategory");
      return React.createElement("li", _extends({
        key: menu.display_name,
        className: classnames(styles.subMenuItem, (_classnames3 = {}, _defineProperty(_classnames3, styles.subMenuItemActive, selectedSubMenu.name === menu.name), _defineProperty(_classnames3, styles.clickable, true), _classnames3))
      }, interaction), menu.display_name, React.createElement(SVGIcon, {
        className: styles.subMenuChevron,
        name: iconName
      }));
    }), selectedCategory.links && selectedCategory.links.map(function (link) {
      return React.createElement("li", {
        key: link.text,
        className: classnames(styles.subMenuItem, _defineProperty({}, styles.saleMenuItem, link.is_sale))
      }, link.is_sale && React.createElement(SVGIcon, {
        className: styles.saleTag,
        name: "tag"
      }), React.createElement("a", {
        href: link.url,
        className: styles.subMenuLink
      }, link.text));
    })), hideItems && React.createElement("button", {
      type: "button",
      className: styles.moreButton,
      onClick: function onClick() {
        return setExpandedCategories(_objectSpread({}, expandedCategories, _defineProperty({}, selectedCategory.name, true)));
      }
    }, "+ ", gettext("burger_menu.more_category_link"), " "), React.createElement("ul", {
      className: styles.trendList
    }, selectedCategory.trend_menus && selectedCategory.trend_menus.map(function (trendMenu) {
      var _classnames5;

      function interact() {
        setSelectedSubMenu(trendMenu);
        setSelectedTrendMenu(null);
      }

      var interaction = getInteraction(interact, "Trends");
      return React.createElement("li", _extends({
        key: trendMenu.display_name,
        className: classnames(styles.subMenuItem, styles.trendItem, (_classnames5 = {}, _defineProperty(_classnames5, styles.subMenuItemActive, selectedSubMenu.name === trendMenu.name), _defineProperty(_classnames5, styles.clickable, true), _classnames5))
      }, interaction), trendMenu.display_name, React.createElement(SVGIcon, {
        className: styles.subMenuChevron,
        name: iconName
      }));
    })));
  }

  function renderSubCategoryLinks() {
    return React.createElement("ul", {
      className: styles.subMenu
    }, Array.isArray(selectedSubMenu.links) && selectedSubMenu.links.map(function (link) {
      if (link.url === "") return;
      return React.createElement("li", {
        key: link.text,
        className: classnames(styles.subMenuItem, _defineProperty({}, styles.saleMenuItem, link.is_sale))
      }, link.is_sale && React.createElement(SVGIcon, {
        className: styles.saleTag,
        name: "tag"
      }), React.createElement("a", {
        href: link.url,
        className: styles.subMenuLink
      }, link.text));
    }), Array.isArray(selectedSubMenu.trend_menus) && selectedSubMenu.trend_menus.map(function (trendMenu) {
      var _classnames7;

      var interaction = getInteraction(function () {
        return setSelectedTrendMenu(trendMenu);
      }, "Trends");
      return React.createElement("li", _extends({
        key: trendMenu.display_name,
        className: classnames(styles.subMenuItem, styles.trendItem, (_classnames7 = {}, _defineProperty(_classnames7, styles.subMenuItemActive, selectedTrendMenu && selectedTrendMenu.name === trendMenu.name), _defineProperty(_classnames7, styles.clickable, true), _classnames7))
      }, interaction), trendMenu.display_name, React.createElement(SVGIcon, {
        className: styles.subMenuChevron,
        name: iconName
      }));
    }));
  }

  function renderTrendLinks() {
    if (!selectedTrendMenu) return;
    return React.createElement("ul", {
      className: styles.subMenu
    }, selectedTrendMenu.links.map(function (link) {
      return React.createElement("li", {
        key: link.url,
        className: classnames(styles.subMenuItem, _defineProperty({}, styles.saleMenuItem, link.is_sale))
      }, React.createElement("a", {
        href: link.url,
        className: styles.subMenuLink
      }, link.text));
    }));
  }

  function renderPopularBrands() {
    return React.createElement("div", {
      className: styles.subMenusContainer
    }, React.createElement("div", {
      className: styles.popularBrands
    }, React.createElement("span", {
      className: styles.subMenuTitle
    }, gettext("app_header_menu.popular_brands")), React.createElement("ul", {
      className: styles.popularBrandsList
    }, popularBrands.map(function (link) {
      return React.createElement("li", {
        key: link.url,
        className: classnames(styles.subMenuItem, styles.popularBrandItem)
      }, React.createElement("a", {
        href: link.url,
        className: classnames(styles.subMenuLink)
      }, link.text));
    }))), React.createElement("div", null, React.createElement("span", {
      className: styles.subMenuTitle
    }, gettext("app_header_menu.brands_a_z")), React.createElement("div", {
      className: styles.brandLetters
    }, letters.map(function (letter) {
      return React.createElement("a", {
        key: "brand-initial-".concat(letter),
        href: "".concat(featuredDesignersUrl, "#").concat(letter),
        className: styles.brandLetter
      }, letter);
    })), React.createElement("a", {
      href: featuredDesignersUrl,
      className: styles.viewAllBrands
    }, gettext("app_header_menu.view_all"))));
  }

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classnames(styles.mainNavigationOverlay, _defineProperty({}, styles.show, showContent)),
    onClick: function onClick() {
      dispatch(hideMainNavigation());
    }
  }), React.createElement("div", {
    className: classnames(styles.mainNavigationDesktop, _defineProperty({}, styles.show, showContent))
  }, renderCategories(), React.createElement(CloseButton, {
    className: styles.closeButton,
    onClick: function onClick() {
      dispatch(hideMainNavigation());
    }
  }), popularBrands ? renderPopularBrands() : React.createElement("div", {
    className: styles.subMenusContainer
  }, renderSubCategories(), renderSubCategoryLinks(), renderTrendLinks())));
}
MainNavigationDesktop.propTypes = {
  menuData: PropTypes.shape({
    menus: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      menus: PropTypes.array,
      trend_menus: PropTypes.array
    })).isRequired,
    links: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      is_sale: PropTypes.bool,
      url: PropTypes.string
    }))
  }),
  featuredDesignersUrl: PropTypes.string.isRequired
};
export default withReduxProvider(MainNavigationDesktop);